import React from "react";

/**
 * Kostaja credit badge — rendered by React so it persists regardless of
 * any platform script that manipulates DOM in the base HTML.
 *
 * Layout logic:
 *   • Desktop (lg+): full pill with logo + "Made by Kostaja" text
 *   • Mobile: icon-only tap target (~40px) so it never fights the sticky CTA for space
 *   • When the sticky CTA is visible on mobile, the badge lifts above it
 *     (body[data-sticky-cta="on"] toggle)
 */
export default function KostajaBadge() {
  return (
    <>
      <style>{`
        /* icon-only compact badge on mobile */
        .kostaja-badge { position: fixed; bottom: 12px; right: 12px; z-index: 9999; display: inline-flex; align-items: center; gap: 0; padding: 4px; background: #000; border-radius: 999px; text-decoration: none; box-shadow: 0 6px 20px -8px rgba(0,0,0,0.5); font-family: 'DM Sans', -apple-system, sans-serif; }
        .kostaja-badge__label { display: none; color: #fff; font-size: 12px; font-weight: 600; line-height: 18px; white-space: nowrap; padding-right: 8px; padding-left: 6px; }
        .kostaja-badge__mark { width: 32px; height: 32px; border-radius: 6px; display: block; }

        /* Lift above sticky mobile CTA when active */
        body[data-sticky-cta="on"] .kostaja-badge { bottom: 66px; transition: bottom 260ms ease; }

        /* Desktop — full pill */
        @media (min-width: 1024px) {
          .kostaja-badge { padding: 4px 12px 4px 4px; }
          .kostaja-badge__label { display: inline; }
          .kostaja-badge__mark { width: 24px; height: 24px; border-radius: 5px; }
        }
      `}</style>
      <a
        className="kostaja-badge"
        href="https://kostaja.ca"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Website created by Kostaja"
        data-testid="kostaja-credit-badge"
      >
        <img
          className="kostaja-badge__mark"
          src="https://customer-assets.emergentagent.com/job_listing-standard/artifacts/5mkhl3sz_Original%20Logo%20Symbol.png"
          alt=""
        />
        <span className="kostaja-badge__label">Made by Kostaja</span>
      </a>
    </>
  );
}
